import { render } from "./AddAndUpdatePostLabels.vue?vue&type=template&id=b6a46bfc&scoped=true"
import script from "./AddAndUpdatePostLabels.vue?vue&type=script&lang=js"
export * from "./AddAndUpdatePostLabels.vue?vue&type=script&lang=js"

import "./AddAndUpdatePostLabels.vue?vue&type=style&index=0&id=b6a46bfc&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a46bfc"]])

export default __exports__